
/**
 * Clase `ObsWindowView` que gestiona la vista de la ventana de observaciones.
 * Proporciona métodos para actualizar y cerrar la ventana de detalles.
 */
class ObsWindowView{

    /**
     * El elemento HTML para la ventana de detalles.
     * @private
     */
    private obsWindow: HTMLElement;

    /**
     * Booleano que indica si está o no abierta la ventana de detalles
     * @private
     */
    private isopen: boolean = false;

    /**
     * Función que notifica cuando se ha abierto o cerrado una ventana
     * @private
     */
    private notify: ((open: boolean) => any) | undefined | null = null;

    /**
     * Constructor de la clase `ObsWindowView`.
     * Inicializa la ventana de observaciones y configura los eventos necesarios.
     *
     * @param {HTMLElement} obsWindow - El elemento HTML de la ventana de observaciones.
     */
    constructor(obsWindow: HTMLElement){
        this.obsWindow = obsWindow;

        if (this.obsWindow){

            const event = new Event('closeMenus');
            document.dispatchEvent(event);

            // Icono de cerrar menus
            const iconos_close_menus : any = this.obsWindow.getElementsByClassName(" close");

            // Se añade el listener para cerrar el menu
            for (const icono_close of iconos_close_menus) {
                icono_close.addEventListener("click", this.close.bind(this) );
            }

            document.addEventListener("closeMenus", this.close.bind(this));


        }

    }

    /**
     * Cierra la ventana de detalles.
     * Cambia el estado de la ventana a cerrada y notifica si es necesario.
     */
    public close(){
        this.isopen = false;

        this.obsWindow?.classList.remove("open");

        if (this.notify)
            this.notify(false);

    }


    /**
     * Actualiza la ventana de detalles con los datos proporcionados.
     * Modifica el contenido de la ventana y ajusta su estado según los datos.
     *
     * @param {any} data - Los datos para actualizar la ventana de observaciones.
     */
    public update(data: any) {
        if (data.name) {
            const title = this.obsWindow.querySelector('.title');
            if (title) {
                title.innerHTML = data.name;
                (title as HTMLElement).title = data.name;
            }
        }
        if (data.msg) {
            const stationinfo = this.obsWindow.querySelector('.stationinfo .info');
            if (stationinfo)
                stationinfo.innerHTML = data.msg;
        }

        const stationdata = this.obsWindow.querySelector('.stationdata');

        if (stationdata) {
            while (stationdata.firstChild) {
                stationdata.removeChild(stationdata.firstChild);
            }

            // Itera sobre las claves de datos y actualiza la información de la ventana
            ["obs", "temp", "wind", "prec", "humidity", "visibility", "aqindex", "no2", "o3", "pm10", "pm2p5", "so2", "co"].forEach((key) => {
                if (data[key]) {
                    let hiddenClass = "";
                    if (data[key].color === null || data[key].iconValue)
                        hiddenClass = "hidden";
                    const div = document.createElement("div");
                    div.classList.add("obsdata");

                    const title = data[key].value.replace(/<div[\s\S]*?>[\s\S]*?<\/div>/gi, '').replace(/<span[\s\S]*?>/gi, '').replace(/<\/span>/gi, '');
                    div.innerHTML = `<span class="titleandicon">
                                    <span class="title">${data[key].title}:</span>
                                    <img src="${data[key].icon}" alt="${data[key].title}" width="24" height="24">
                                </span>
                                <span class="data">
                                    <span class="color ${hiddenClass}" style="background-color: ${data[key].color};"></span>
                                    <span class="value" title="${title}">${data[key].value}</span>
                                </span>`;

                    const iconfont = div.querySelector('.iconfont');
                    if (iconfont) {
                        (iconfont as HTMLElement).style.color = data[key].color;
                    }

                    if (data[key].class !== undefined) {
                        div.classList.add(data[key].class);
                    }

                    stationdata.appendChild(div);
                }
            });

            // Ajusta el número de columnas según los datos
            if (data.ncolumns) {
                if (data.ncolumns === 1) {
                    this.obsWindow.classList.remove("row2");
                    this.obsWindow.classList.add("row1");
                } else if (data.ncolumns === 2) {
                    this.obsWindow.classList.remove("row1");
                    this.obsWindow.classList.add("row2");
                } else
                    this.obsWindow.classList.remove("row1", "row2");
            }
        }

        if (!this.isopen) {
            const event = new Event('closeMenus');
            document.dispatchEvent(event);
            this.obsWindow.classList.add("open");
        }

        this.isopen = true;
        if (this.notify)
            this.notify(true);
    }




}


export default ObsWindowView;
